import axios, { AxiosRequestConfig } from "axios";
import { keycloak, setHeaderOnConfig } from "../components/secured/Auth";
import { ErrorMessage } from "../models/error";

const apiGate = axios.create({
	baseURL: process.env.REACT_APP_API_GATEWAY,
	timeout: 50000,
});
apiGate.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		if (error.response && error.response.status === 401) {
			window.location.href = process.env.REACT_APP_NGINX_ENDPOINT + "";
		}
		let errorMessage: ErrorMessage = {
			code: "E610SISTEC0500",
			level: "error",
			message: "Ocorreu um erro interno na aplicação. Por favor, tente novamente ou entre em contato com o suporte.",
		};
		if (error.response) {
			if (error.response.data) {
				errorMessage = error.response.data;
			} else {
				errorMessage = error;
			}
			errorMessage.level = "warning";
			return Promise.reject(errorMessage);
		}
		return Promise.reject(errorMessage);
	}
);
apiGate.interceptors.request.use((config: AxiosRequestConfig) => {
	return new Promise((resolve) => {
		keycloak
			.updateToken(40)
			.success((hasRefreshed) => {
				if (hasRefreshed && keycloak && keycloak.token) {
					sessionStorage.setItem("token", keycloak.token);
				}
				return resolve(setHeaderOnConfig(config));
			})
			.error(() => {
				return resolve(setHeaderOnConfig(config));
			});
	});
});

export default apiGate;
